var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row px-1"},_vm._l((_vm.legend_data_color),function(color,index){return _c('div',{key:index+'legend',staticClass:"box3 d-flex align-items-center justify-content-center",style:({'background-color':color,'font-size': '15px'})},[_vm._v(_vm._s(_vm.legend_data_value[index]))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }